module.exports = __webpack_public_path__ + "static/person-male-e6b620e1a6278ba1eacbb7261f7b90f4.png";